import { render, staticRenderFns } from "./registrationranking.vue?vue&type=template&id=f901aa70&"
import script from "./registrationranking.vue?vue&type=script&lang=js&"
export * from "./registrationranking.vue?vue&type=script&lang=js&"
import style0 from "./registrationranking.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports